import { NavigationLink } from '@/graphql/__generated/sdk';
import { ONE_TRUST_TOGGLE } from '@/constants';

export const isNavLink = (link: unknown): link is NavigationLink => {
	return typeof link === 'object' && link !== null && 'externalUrl' in link;
};

export const isOneTrustLink = (navigationLink: NavigationLink | null) => {
	return navigationLink && isNavLink(navigationLink) && navigationLink.externalUrl?.includes(ONE_TRUST_TOGGLE);
};
